module.exports = __webpack_public_path__ + "cf.037865b5.svg";